import { render, staticRenderFns } from "./activitiesReviewa.vue?vue&type=template&id=31bf2994&scoped=true&"
import script from "./activitiesReviewa.vue?vue&type=script&lang=js&"
export * from "./activitiesReviewa.vue?vue&type=script&lang=js&"
import style0 from "./activitiesReviewa.vue?vue&type=style&index=0&id=31bf2994&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf2994",
  null
  
)

export default component.exports